// src/components/ProjectManagement/WorkerDropZone.jsx
import React, { useState } from 'react';
import { useDroppable } from '@dnd-kit/core';
import WorkerTasksModal from './WorkerTasksModal';

const WorkerDropZone = ({ worker }) => {
  const [showTasksModal, setShowTasksModal] = useState(false);
  const { setNodeRef, isOver } = useDroppable({ 
    id: `worker-${worker.id}`, 
    data: { worker } 
  });
  
  // Ensure currentLoad is a number and exists
  const activeTasks = worker.currentLoad !== undefined ? worker.currentLoad : 0;
  const loadPercentage = Math.min((activeTasks / 15) * 100, 100);
  
  const getLoadColor = () => {
    if (loadPercentage < 30) return '#10b981';
    if (loadPercentage < 70) return '#f59e0b';
    return '#ef4444';
  };

  const handleClick = (e) => {
    e.stopPropagation();
    setShowTasksModal(true);
  };

  const formatRole = (role) => {
    if (!role) return 'Team Member';
    return role.replace(/-/g, ' ').replace(/_/g, ' ');
  };

  return (
    <>
      <div 
        ref={setNodeRef} 
        className={`worker-card ${isOver ? 'drag-over' : ''}`}
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
      >
        <div className="worker-avatar">
          <div className="avatar-placeholder" style={{ background: `linear-gradient(135deg, var(--maroon-primary), var(--maroon-dark))` }}>
            {worker.name?.charAt(0).toUpperCase() || 'U'}
          </div>
          <div className={`worker-status ${activeTasks > 0 ? 'busy' : 'free'}`}></div>
        </div>
        
        <div className="worker-info">
          <div className="worker-name-row">
            <h4 title={worker.name}>{worker.name || 'Unnamed User'}</h4>
            <span className="worker-role-badge">{formatRole(worker.role)}</span>
          </div>
          
          <div className="worker-stats">
            <div className="stat">
              <span className="stat-icon">📋</span>
              <span className="stat-value">{activeTasks}</span>
              <span>active {activeTasks === 1 ? 'task' : 'tasks'}</span>
            </div>
            <div className="stat">
              <span className="stat-icon">⚡</span>
              <span className="stat-value">{loadPercentage.toFixed(0)}%</span>
              <span>load</span>
            </div>
          </div>
          
          <div className="load-bar-container">
            <div className="load-bar-fill" style={{ width: `${loadPercentage}%`, background: getLoadColor() }} />
          </div>
        </div>
        
        {isOver && (
          <div className="drop-overlay">
            <span>↓ Drop to assign</span>
          </div>
        )}
      </div>

      {showTasksModal && (
        <WorkerTasksModal
          worker={worker}
          onClose={() => setShowTasksModal(false)}
        />
      )}
    </>
  );
};

export default WorkerDropZone;